module.exports = __webpack_public_path__ + "static/media/me.117fa487.jpg";